/**
 * Within an async function, await this function to pause for a given number of milliseconds.
 * @param delay - The number of milliseconds to pause for.
 * @returns A promise that resolves after the given delay.
 */
export function sleep(delay: number) {
  return new Promise((resolve) => setTimeout(resolve, delay));
}
